import { render, staticRenderFns } from "./VersionPie.vue?vue&type=template&id=242cd93c&scoped=true"
import script from "./VersionPie.vue?vue&type=script&lang=js"
export * from "./VersionPie.vue?vue&type=script&lang=js"
import style0 from "./VersionPie.vue?vue&type=style&index=0&id=242cd93c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242cd93c",
  null
  
)

export default component.exports